import React, { memo } from "react";
import styled from "styled-components/macro";
import colors from "constants/colors";

import "./index.scss";

interface DaikinLogoHTMLProps {
  width: number;
  theme?: "white" | "black-blue";
  type?: "small" | "large";
}

const DaikinLogoHTML: React.FC<DaikinLogoHTMLProps> = ({
  theme = "black-blue",
  type = "small",
  width,
}) => {
  return (
    <Container width={width} theme={theme}>
      <RecOuter width={width} theme={theme} type={type}></RecOuter>
      <RecInner width={width} theme={theme}></RecInner>
    </Container>
  );
};

const Box = styled.div`
  position: absolute;
  top: 0;
  left: 0;
`;

const RecInner = styled(Box)<DaikinLogoHTMLProps>`
  border: ${({ width }) => `${width / 4.5}px`} solid
    ${({ theme }) => (theme === "black-blue" ? colors.black : colors.white)};
  border-right-color: transparent;
  border-bottom-color: transparent;
`;

const RecOuter = styled(Box)<DaikinLogoHTMLProps>`
  border: ${({ width, type = "small" }) =>
      `${
        type === "small" ? `${width / 4.5 + 1 / 2}px` : `${width / 4.5 + 1}px`
      }`}
    solid
    ${({ theme }) =>
      theme === "black-blue" ? "white" : colors.richElectricBlue};
  border-right-color: transparent;
  border-bottom-color: transparent;
`;

const Container = styled.div<DaikinLogoHTMLProps>`
  width: 100%;
  border: ${({ width }) => `${width / 2}px`} solid
    ${({ theme }) =>
      theme === "black-blue" ? colors.pictonBlue2 : colors.white};
  border-right-color: transparent;
  border-bottom-color: transparent;

  /* keep ratio container */
  &:before {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`;

DaikinLogoHTML.defaultProps = {};

export default memo(DaikinLogoHTML);
